/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, September 23rd 2022, 9:35:18 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { EmptyStateActionWrapper, Image } from "ui-widgets";

export const EmptyFieldValidatorsCTA = () => {
  return (
    <>
      <EmptyStateActionWrapper
        title="No Field Validators"
        description={
          <>
            No field validators are setup yet for this field. Use field validators to enable validation of field values
            entered by users against your own datasets.
          </>
        }
        illustrationGraphic={<Image className="image-style-A" src="/img/approved.png" alt="Onestop Admin" />}
      ></EmptyStateActionWrapper>
    </>
  );
};
